module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-react-router-scroll/~/babel-runtime/core-js/symbol/iterator.js
// module id = ./node_modules/gatsby-react-router-scroll/node_modules/babel-runtime/core-js/symbol/iterator.js
// module chunks = 168707334958949